import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../../../../hooks";
import { activateServer } from "../../../../api";
import "./ServerForm.scss";

export function ActivateServerForm({ onClose, onReload, initialServerKey }) {
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: { serverKey: initialServerKey || "", institutionID: "" },
    validationSchema: Yup.object({
      serverKey: Yup.string().trim().required("Requerido"),
      institutionID: Yup.string().trim().required("Requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        await activateServer(accessToken, {
          serverKey: values.serverKey.trim(),
          institutionID: values.institutionID.trim(),
        });
        onReload();
        onClose();
      } catch (e) {
        console.error(e);
      }
    },
  });

  return (
    <Form className="activate-server-form" onSubmit={formik.handleSubmit}>
      <Form.Input
        name="serverKey"
        label="Server Key"
        placeholder="srv-001"
        onChange={formik.handleChange}
        value={formik.values.serverKey}
        error={formik.errors.serverKey}
      />
      <Form.Input
        name="institutionID"
        label="Institution ID"
        placeholder="ObjectId de InstitutionSimulator"
        onChange={formik.handleChange}
        value={formik.values.institutionID}
        error={formik.errors.institutionID}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        Activar
      </Form.Button>
    </Form>
  );
}
